import { Redirect, Route, Switch } from 'react-router-dom';
import { VStack } from '@cbhq/cds-web/layout';

import { AppRoute } from ':cloud/utils/routes';
import { RoutedTopNavTabs } from ':cloud/widgets/sharedcomponents/RoutedTopNavTabs';

import { BillingPage } from './Billing';
import { UsagePage } from './UsagePage';

const tabs = [
  {
    id: 'details',
    label: 'Details',
    route: AppRoute.Billing.Details,
  },
  {
    id: 'usage',
    label: 'Usage',
    route: AppRoute.Billing.Usage,
  },
];

export function BillingWithTabs() {
  return (
    <VStack width="100%">
      <RoutedTopNavTabs tabs={tabs} />
      <Switch>
        <Route exact path={AppRoute.Billing.Details}>
          <BillingPage />
        </Route>
        <Route exact path={AppRoute.Billing.Usage}>
          <UsagePage />
        </Route>
        <Redirect to={AppRoute.Billing.Details} />
      </Switch>
    </VStack>
  );
}
